module.exports = __webpack_public_path__ + "static/media/warn2.7a77aae2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/warn2.jpg
// module id = 346
// module chunks = 2